var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "referrer_box" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "page-title" }, [_vm._v("FAQ's")])
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "back-col", attrs: { span: 12 } }, [
            _c(
              "span",
              {
                staticClass: "btn-back",
                on: {
                  click: function($event) {
                    return _vm.goBack()
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("BACK")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            display: "flex",
            "align-items": "end",
            "margin-top": "15px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "create-faq-btn",
                  on: { click: _vm.navigateToCreateFaq }
                },
                [_vm._v("Create FAQ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-table",
                { staticStyle: { width: "100%" }, attrs: { data: _vm.faqs } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "position",
                      "min-width": "50",
                      label: "Position"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "question",
                      "min-width": "150",
                      label: "Question"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "answer",
                      "min-width": "200",
                      label: "Answer"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created",
                      "min-width": "100",
                      label: "Created Date"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.util.formatDate(scope.row.created))
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { "min-width": "80px", label: "Actions" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(action) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "edit-link",
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-edit"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleClickEditFaq(
                                      action.row.faqId
                                    )
                                  }
                                }
                              },
                              [_vm._v("Edit")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "divider" }, [
                              _vm._v(" | ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "remove-link",
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-delete"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleClickDeleteFaq(
                                      action.row.faqId
                                    )
                                  }
                                }
                              },
                              [_vm._v("Delete")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalFaqs
                ? _c(
                    "div",
                    { staticClass: "fen" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.pageFaqs,
                          "page-size": 25,
                          layout: "total, prev, pager, next",
                          total: _vm.totalFaqs
                        },
                        on: { "current-change": _vm.handleCurrentChange }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cdb31de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cdb31de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/allFaq.vue
// module id = null
// module chunks = 